import { gql } from "apollo-boost"

export const GET_SUBMISSION_PROFILE_COMPLETENESS = gql`
  query ImplementerByUid($userImplementerId: String!) {
    ImplementerByUidBriefVersion(uid: $userImplementerId) {
      rfc
      name
      email
      phone
      director
      legalRepresentative
    }
  }
`
